import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  green6,
  grey1,
  grey6,
  orange5,
} from 'approot/shared/styles/colours.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { spacing12, spacing16 } from 'approot/shared/styles/spacing.style';
import { SecondaryButtonAndIconLink } from 'approot/shared/styles/buttons/secondary-button.style';

export const PresentMenuStudentsContainer = styled(Box).attrs({
  $gap: spacing12,
})`
  padding: ${rem(spacing16)} 0;
`;

export const PresentMenuAddStudents = styled(Box)`
  ${SecondaryButtonAndIconLink} {
    width: 100%;
  }
`;

export const EmptyStateImg = styled.img`
  width: 100%;
`;

type StatusIndicatorProps = {
  $isOnline?: boolean;
  $isNeutral?: boolean;
};

export const StatusIndicator = styled.div<StatusIndicatorProps>`
  width: ${rem(14)};
  height: ${rem(14)};
  border-radius: 50%;
  border: 2px solid ${grey1};
  background-color: ${({ $isOnline, $isNeutral }) =>
    $isOnline ? green6 : $isNeutral ? orange5 : grey6};
  position: absolute;
  right: 0;
  bottom: 0;
`;

export const StudentAvatar = styled(Box).attrs({
  $alignItems: 'center',
  $justifyContent: 'center',
})`
  flex-shrink: 0;
  position: relative;
  width: ${rem(40)};
  height: ${rem(40)};
`;
